import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useTrocaTabelaHorarioContext } from 'pages/TrocaTabelaHorarios'
import { useParams } from 'react-router-dom'
import { tabelaHorarios, trocaHorario } from 'service/api'
import { toast } from 'sonner'
import { encontrarTroca } from './encontrar-troca'

export default function ExcluirTrocaTabelaHorario() {
    const { id } = useParams<{ id: string }>()
    const { data } = useTrocaTabelaHorarioContext()
    const { mutateAsync, isLoading } =
        tabelaHorarios.funcionario.mutations.useDelete({
            invalidateQuery: true,
        })

    const tabela = encontrarTroca(data, id)
    if (!tabela || tabela.isTrocaAutomatica) return null

    function handleSubmit() {
        return mutateAsync(Number(tabela!.id), {
            onSuccess: () => {
                toast.success('Tabela removida com sucesso!')
                trocaHorario.invalidateQueries()
            },

            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <Dialog.Root
            open={hasPermission(['delete', 'TrocaDeTabelaDeHorário'])}
            width="auto"
            height="auto"
            onSubmit={handleSubmit}
            loading={isLoading}
        >
            <Dialog.Content>
                Tem certeza que deseja excluir a troca de tabela?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error" closeOnSubmit>
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
